import styles from './BrandLogo.module.css';

interface BrandLogoProps {
  // 'wordmark' = full "Openline" lockup; 'icon' = the square mark only.
  variant?: 'wordmark' | 'icon';
  // Rendered height in px; width scales with the SVG's aspect ratio.
  height?: number;
  className?: string;
}

// Renders both the light- and dark-background logo variants and lets CSS pick
// the right one based on the active theme ([data-theme] / system preference),
// so the mark always has contrast against the surface it sits on.
export function BrandLogo({ variant = 'wordmark', height = 28, className }: BrandLogoProps) {
  const base = variant === 'icon' ? 'openline-icon' : 'openline-logo';
  return (
    <span
      className={[styles.logo, className].filter(Boolean).join(' ')}
      style={{ height: `${height}px` }}
    >
      {/* Both variants are rendered; CSS shows the one matching the active
          theme (see BrandLogo.module.css). Rendering only one left the logo
          invisible under the opposite theme. BASE_URL ('/agent/' in prod, '/'
          in dev) — an absolute '/logos/…' would 404 under a base path. */}
      <img
        className={styles.light}
        src={`${import.meta.env.BASE_URL}logos/${base}-light.svg?v=openline`}
        alt="Openline"
      />
      <img
        className={styles.dark}
        src={`${import.meta.env.BASE_URL}logos/${base}-dark.svg?v=openline`}
        alt="Openline"
      />
    </span>
  );
}
